<template>
    <v-container id="hitnrun-dialog">
        <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->

        <v-dialog v-model="dialog" persistent scrollable max-width="1200px" :fullscreen="$vuetify.breakpoint.mobile">

            <v-card max-height="900px" class="backdrop dialog-card">

                <v-overlay absolute :value="overlay_loading">
                    <v-progress-circular indeterminate :size="80" :width="7"
                                         color="secondary"></v-progress-circular>
                </v-overlay>

                <v-card-title class="backdrop lighten-1 dialog-title">
                    <span class="text-h5">{{customTitle()}}</span>
                </v-card-title>
                <v-card-text class="backdrop pa-0 white--text">
                    <v-container>

                        <v-form v-model="valid" ref="form">
                            <!--ASSIGNMENT:-->
                            <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">

                                <div class="text-h6 mb-2"> ASSIGNMENT : </div>
                                <v-row>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-select :items="['ASSIGNED', 'OPEN', 'CLOSED', 'PENDING', 'SUBMITTED']" v-model="field_incident.status"
                                                  label="STATUS*" placeholder="Select a status" :rules="[field_rules.required]" maxlength="60">

                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-select :items="user_records" item-text="proper_name" item-value="hitnrun_usersId" v-model="field_incident.hitnrun_usersId_hitrunID"
                                                  label="DETECTIVE/OFFICER" placeholder="Select a detective/officer" maxlength="60">

                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-select :items="['YES', 'NO', 'MAIT']" v-model="field_incident.priority"
                                                  label="PRIORITY*" placeholder="YES/NO" maxlength="60" :rules="[field_rules.required]">

                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-text-field label="CASE #*" maxlength="10" v-model="field_incident.case_num"
                                                      placeholder="20-1234" :rules="[field_rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-text-field label="ASSIGNED DATE" type="date" v-model="field_incident.assigned_date"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-text-field label="CLOSED DATE" type="date" v-model="field_incident.closed_date"></v-text-field>
                                    </v-col>
                                </v-row>

                            </div>

                            <!--INCIDENT INFO:-->
                            <div class="ma-2"></div>
                            <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">

                                <div class="text-h6 mb-2"> INCIDENT INFO : </div>
                                <v-row>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-text-field label="INCIDENT DATE" type="date" v-model="field_incident.incident_date"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-text-field label="INCIDENT TIME" type="text" v-mask="'####'" v-model="field_incident.incident_time"
                                                      maxlength="4" placeholder="1330"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-text-field label="INCIDENT LOCATION" v-model="field_incident.incident_location"
                                                      maxlength="60" placeholder="East Prater Way"></v-text-field>
                                    </v-col>

                                </v-row>

                            </div>

                            <!--SUSPECT DRIVER:-->
                            <div class="ma-2"></div>
                            <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">

                                <div class="text-h6 mb-2"> SUSPECT DRIVER : </div>
                                <v-row>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="NAME" v-model="field_incident.sus_name"
                                                      maxlength="60" placeholder="John Smith"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="ADDRESS" v-model="field_incident.sus_address"
                                                      maxlength="60" placeholder="234 Elm St"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="CITY" v-model="field_incident.sus_city"
                                                      maxlength="60" placeholder="Reno"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="STATE" v-model="field_incident.sus_state"
                                                      maxlength="2" placeholder="NV"></v-text-field>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="ZIPCODE" v-mask="'##########'" v-model="field_incident.sus_zip"
                                                      maxlength="10" placeholder="89506"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="PHONE" v-model="field_incident.sus_phone"
                                                      v-mask="'(###) ###-####'"
                                                      placeholder="(775) 555-5555"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="DOB" type="date" v-model="field_incident.sus_DOB"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="DRIVER'S LIC #" v-model="field_incident.sus_DL_num"
                                                      v-mask="'################'" placeholder="123456789123"></v-text-field>
                                    </v-col>

                                </v-row>

                            </div>

                            <!--SUSPECT VEHICLE:-->
                            <div class="ma-2"></div>
                            <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">

                                <div class="text-h6 mb-2"> SUSPECT VEHICLE : </div>
                                <v-row>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="REGISTERED OWNER NAME" v-model="field_incident.sus_veh_name"
                                                      maxlength="60" placeholder="John Smith"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="ADDRESS" v-model="field_incident.sus_veh_address"
                                                      maxlength="60" placeholder="234 Elm St"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="CITY" v-model="field_incident.sus_veh_city"
                                                      maxlength="60" placeholder="Reno"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="STATE" v-model="field_incident.sus_veh_ad_state"
                                                      maxlength="2" placeholder="NV"></v-text-field>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="ZIPCODE" v-mask="'##########'" v-model="field_incident.sus_veh_zip"
                                                      maxlength="10" placeholder="89506"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="VEHICLE YEAR" v-model="field_incident.sus_veh_year"
                                                      v-mask="'####'"
                                                      maxlength="4" placeholder="2003"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="MAKE" v-model="field_incident.sus_veh_make"
                                                      maxlength="60" placeholder="Toyota"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="MODEL" v-model="field_incident.sus_veh_model"
                                                      maxlength="60" placeholder="Hatchback"></v-text-field>
                                    </v-col>

                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="LICENSE PLATE" v-model="field_incident.sus_veh_lic_num"
                                                      maxlength="10" placeholder="CVA323"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="LICENSE STATE" v-model="field_incident.sus_veh_state"
                                                      maxlength="2" placeholder="NV"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field label="INSURANCE COMPANY" v-model="field_incident.sus_veh_insco"
                                                      maxlength="60" placeholder="Allstate"></v-text-field>
                                    </v-col>

                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field label="POLICY #" v-model="field_incident.sus_veh_policy_num"
                                                      maxlength="60" placeholder="AJFJJS1568412"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field label="CLAIMS PHONE" v-model="field_incident.sus_veh_claimsph_num"
                                                      v-mask="'(###) ###-####'"
                                                      placeholder="(775) 555-5555"></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>

                            <!--VICTIM VEHICLE:-->
                            <div class="ma-2"></div>
                            <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">

                                <div class="text-h6 mb-2"> VICTIM VEHICLE : </div>
                                <v-row>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="REGISTERED OWNER NAME" v-model="field_incident.vic_veh_reg_owner_name"
                                                      maxlength="60" placeholder="John Smith"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="VICTIM NAME" v-model="field_incident.vic_veh_name"
                                                      maxlength="60" placeholder="Sally Smith"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="REGISTERED OWNER PHONE" v-model="field_incident.vic_veh_phone"
                                                      v-mask="'(###) ###-####'"
                                                      placeholder="(775) 555-5555"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="ADDRESS" v-model="field_incident.vic_veh_address"
                                                      maxlength="60" placeholder="234 Elm St"></v-text-field>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="CITY" v-model="field_incident.vic_veh_city"
                                                      maxlength="60" placeholder="Reno"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="STATE" v-model="field_incident.vic_veh_ad_state"
                                                      maxlength="2" placeholder="NV"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="ZIPCODE" v-model="field_incident.vic_veh_zip"
                                                      v-mask="'##########'"
                                                      maxlength="10" placeholder="89506"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="VEHICLE YEAR" v-model="field_incident.vic_veh_year"
                                                      v-mask="'####'"
                                                      maxlength="4" placeholder="2003"></v-text-field>
                                    </v-col>

                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="MAKE" v-model="field_incident.vic_veh_make"
                                                      maxlength="60" placeholder="Toyota"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="MODEL" v-model="field_incident.vic_veh_model"
                                                      maxlength="60" placeholder="Hatchback"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="LICENSE PLATE" v-model="field_incident.vic_veh_lic_num"
                                                      maxlength="10" placeholder="CVA323"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="LICENSE STATE" v-model="field_incident.vic_veh_state"
                                                      maxlength="2" placeholder="NV"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="INSURANCE COMPANY" v-model="field_incident.vic_veh_insco"
                                                      maxlength="60" placeholder="Allstate"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="POLICY #" v-model="field_incident.vic_veh_policy_num"
                                                      maxlength="60" placeholder="AJFJJS1568412"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="CLAIMS PHONE" v-model="field_incident.vic_veh_claimsph_num"
                                                      v-mask="'(###) ###-####'"
                                                      placeholder="(775) 555-5555"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field label="VIC CLAIM #" v-model="field_incident.vic_veh_claim_number"
                                                      maxlength="60" placeholder="AJFJJS1568412"></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>

                            <!--Note:-->
                            <div class="ma-2"></div>
                            <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">

                                <div class="text-h6 mb-2"> NOTE : </div>
                                <v-textarea maxlength="4000" label="NOTE ENTRY" v-model="field_incident.note" outlined></v-textarea>
                            </div>
                        </v-form>

                    </v-container>
                    <small class="mx-4">*indicates required fields</small>
                </v-card-text>

                <v-card-actions class="backdrop lighten-1 border-card">
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" class="black--text"
                           @click="closeDialog">
                        Close
                    </v-btn>
                    <v-btn color="secondary" class="black--text" :disabled="!valid"
                           @click="saveIncident">
                        Save
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>

    </v-container>
</template>

<style lang="scss" scoped>
    @import "../scss/site.scss";

    .dialog-card {
        box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
    }

    .dialog-title {
        margin-bottom: 2px;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
    }

    .custom-divider {
        height: 2px;
        background-color: black;
    }

    .border-card {
        margin: 2px;
    }
</style>

<script>
    /* eslint-disable */
    import { bus_common } from "../mixins/bus_common";
    export default {
        name: "hitnrun-dialog",
        mixins: [bus_common],
        props: ["incident_dialog_ID"],
        data() {
            return {
                dialog: true,
                valid: false,
                overlay_loading: false,
                field_rules: {
                    required: value => !!value || 'This field is required',
                    min: v => v.length >= 8 || 'Min 8 characters',
                    max25: v => v.length <= 60 || 'Max 60 characters',
                    email: value => {
                        const pattern = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                        return pattern.test(value) || 'Please provide a valid email address'
                    },
                    min_phone: v => v.length >= 14 || 'Please enter a complete phone number',
                    phone: value => {
                        const pattern = /^\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^\d{10}$|^1\s\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^(1\s?)?\(\d{3}\)(\s|\-)?\d{3}\-\d{4}$/;
                        return pattern.test(value) || 'Please provide a valid phone number'
                    },
                },
                field_incident: {
                    hitrunID: this.incident_dialog_ID,
                    hitnrun_usersId_hitrunID: 0,
                    status: "",
                    priority: "",
                    case_num: "",
                    incident_date: "",
                    assigned_date: "",
                    closed_date: "",
                    incident_time: "",
                    incident_location: "",
                    sus_name: "",
                    sus_address: "",
                    sus_city: "",
                    sus_state: "",
                    sus_zip: "",
                    sus_phone: "",
                    sus_DOB: "",
                    sus_DL_num: "",
                    sus_veh_name: "",
                    sus_veh_address: "",
                    sus_veh_city: "",
                    sus_veh_ad_state: "",
                    sus_veh_zip: "",
                    sus_veh_phone: "",
                    sus_veh_year: "",
                    sus_veh_make: "",
                    sus_veh_model: "",
                    sus_veh_lic_num: "",
                    sus_veh_state: "",
                    sus_veh_insco: "",
                    sus_veh_policy_num: "",
                    sus_veh_claimsph_num: "",
                    vic_veh_name: "",
                    vic_veh_address: "",
                    vic_veh_city: "",
                    vic_veh_ad_state: "",
                    vic_veh_zip: "",
                    vic_veh_phone: "",
                    vic_veh_year: "",
                    vic_veh_make: "",
                    vic_veh_model: "",
                    vic_veh_lic_num: "",
                    vic_veh_state: "",
                    vic_veh_insco: "",
                    vic_veh_reg_owner_name: "",
                    vic_veh_policy_num: "",
                    vic_veh_claimsph_num: "",
                    vic_veh_claim_number: "",
                    det_off_name: "",
                    det_off_phone: "",
                    note: "",
                    s_del: "f",
                    s_user: this.$store.state.user.email,
                    s_createuser: this.$store.state.user.email,
                    s_createdate: "1900-01-01",
                    s_date: "1900-01-01"
                },
                user_records: [],
                noneuser: {
                    hitnrun_usersId: 0,
                    email_user: "",
                    proper_name: "None",
                    title: "",
                    phone: "",
                    file: null,
                    file_sig_image: "",
                    s_del: "f",
                    s_user: "",
                    s_createuser: "",
                    s_createdate: "1900-01-01",
                    s_date: "1900-01-01"
                }
            };
        },
        methods: {
            customTitle() {
                if (this.field_incident.hitrunID == 0)
                    return "NEW INCIDENT"
                else
                    return "EDITING INCIDENT"
            },
            closeDialog() {
                this.dialog = false;
                setTimeout(() => {
                    this.$emit('closeDialog');
                }, 1000)

            },
            async getUserData() {
                let form = {
                    page: 1,
                    pageSize: -1,
                    sortBy: ["proper_name"],
                    sortDesc: [false]
                };

                await this.$axios.post('api/hitnrunuser/getUsers', form)
                    .then(response => {
                        this.user_records = response.data.lst_users;
                        this.user_records.unshift(this.noneuser);
                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });
            },
            async saveIncident() {

                this.overlay_loading = true;
                var form = JSON.parse(JSON.stringify(this.field_incident));

                //Fix dates, prior to saving using copy of data
                this.fixEmptyDate(form, 'incident_date');
                this.fixEmptyDate(form, 'assigned_date');
                this.fixEmptyDate(form, 'closed_date');
                this.fixEmptyDate(form, 'sus_DOB');

                await this.$axios.post('api/hitnrun/SaveHitnrun', form)
                    .then(response => {
                        this.$emit('refreshData');
                        this.overlay_loading = false;
                        let callback = () => { this.closeDialog(); }
                        this.swall_it("Incident Saved! ", "The incident was successfully saved.", "success", callback, null);
                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                            this.overlay_loading = false;

                        }
                    });

            },
            async getIncidentData() {

                if (this.field_incident.hitrunID != 0) {
                    let form = { hitrunID: this.field_incident.hitrunID };
                    await this.$axios.post('api/hitnrun/getIncident', form)
                        .then(response => {

                            // Ouch
                            this.field_incident.hitnrun_usersId_hitrunID = response.data.hitnrun_usersId_hitrunID;
                            this.field_incident.status = response.data.status;
                            this.field_incident.priority = response.data.priority;
                            this.field_incident.case_num = response.data.case_num;
                            this.field_incident.assigned_date = response.data.assigned_date;
                            this.field_incident.incident_date = response.data.incident_date;
                            this.field_incident.closed_date = response.data.closed_date;
                            this.field_incident.incident_time = response.data.incident_time;
                            this.field_incident.incident_location = response.data.incident_location;

                            this.field_incident.sus_name = response.data.sus_name;
                            this.field_incident.sus_address = response.data.sus_address;
                            this.field_incident.sus_city = response.data.sus_city;
                            this.field_incident.sus_state = response.data.sus_state;
                            this.field_incident.sus_zip = response.data.sus_zip;
                            this.field_incident.sus_phone = response.data.sus_phone;
                            this.field_incident.sus_DOB = response.data.sus_DOB;
                            this.field_incident.sus_DL_num = response.data.sus_DL_num;
                            this.field_incident.sus_veh_name = response.data.sus_veh_name;
                            this.field_incident.sus_veh_address = response.data.sus_veh_address;
                            this.field_incident.sus_veh_city = response.data.sus_veh_city;
                            this.field_incident.sus_veh_ad_state = response.data.sus_veh_ad_state;
                            this.field_incident.sus_veh_zip = response.data.sus_veh_zip;
                            this.field_incident.sus_veh_phone = response.data.sus_veh_phone;
                            this.field_incident.sus_veh_year = response.data.sus_veh_year;
                            this.field_incident.sus_veh_make = response.data.sus_veh_make;
                            this.field_incident.sus_veh_model = response.data.sus_veh_model;
                            this.field_incident.sus_veh_lic_num = response.data.sus_veh_lic_num;
                            this.field_incident.sus_veh_state = response.data.sus_veh_state;
                            this.field_incident.sus_veh_insco = response.data.sus_veh_insco;
                            this.field_incident.sus_veh_policy_num = response.data.sus_veh_policy_num;
                            this.field_incident.sus_veh_claimsph_num = response.data.sus_veh_claimsph_num;

                            this.field_incident.vic_veh_name = response.data.vic_veh_name;
                            this.field_incident.vic_veh_reg_owner_name = response.data.vic_veh_reg_owner_name;
                            this.field_incident.vic_veh_address = response.data.vic_veh_address;
                            this.field_incident.vic_veh_city = response.data.vic_veh_city;
                            this.field_incident.vic_veh_ad_state = response.data.vic_veh_ad_state;
                            this.field_incident.vic_veh_zip = response.data.vic_veh_zip;
                            this.field_incident.vic_veh_phone = response.data.vic_veh_phone;
                            this.field_incident.vic_veh_year = response.data.vic_veh_year;
                            this.field_incident.vic_veh_make = response.data.vic_veh_make;
                            this.field_incident.vic_veh_model = response.data.vic_veh_model;
                            this.field_incident.vic_veh_lic_num = response.data.vic_veh_lic_num;
                            this.field_incident.vic_veh_state = response.data.vic_veh_state;
                            this.field_incident.vic_veh_insco = response.data.vic_veh_insco;
                            this.field_incident.vic_veh_policy_num = response.data.vic_veh_policy_num;
                            this.field_incident.vic_veh_claimsph_num = response.data.vic_veh_claimsph_num;
                            this.field_incident.vic_veh_claim_number = response.data.vic_veh_claim_number;

                            this.field_incident.note = response.data.note;
                            this.field_incident.det_off_name = response.data.det_off_name;
                            this.field_incident.det_off_phone = response.data.det_off_phone;

                            this.field_incident.s_del = response.data.s_del;
                            this.field_incident.s_user = response.data.s_user;
                            this.field_incident.s_createuser = response.data.s_createuser;
                            this.field_incident.s_createdate = response.data.s_createdate;
                            this.field_incident.s_date = response.data.s_date;

                            //Fix dates, prior to using copy of data
                            this.UndoEmptyDateFix(this.field_incident, 'incident_date');
                            this.UndoEmptyDateFix(this.field_incident, 'assigned_date');
                            this.UndoEmptyDateFix(this.field_incident, 'closed_date');
                            this.UndoEmptyDateFix(this.field_incident, 'sus_DOB');

                        }).catch(error => {
                            if (error.response) {
                                this.swall_it("Error!", error.response.data.msg, "error", null, null);
                                setTimeout(() => {
                                    this.closeDialog();
                                }, 500);

                            }
                        });
                }
            },
            fixEmptyDate(object, propname) {
                if (object[propname] == "")
                    object[propname] = '1900-01-01'
            },
            UndoEmptyDateFix(object, propname) {
                if (object[propname] == '0001-01-01T00:00:00' || object[propname] == "1900-01-01T00:00:00")
                    object[propname] = ""
                else {
                    object[propname] = this.$moment(object[propname]).format("YYYY-MM-DD")
                }
            },
            async init() {
                this.overlay_loading = true;
                await this.getUserData();
                await this.getIncidentData();
                this.overlay_loading = false;
            },
        },
        watch: {
            'field_incident.status': {
                handler(val, oldVal) {

                    //When changing status to assigned auto populate field with today's date only if previously not filled in
                    if (val == "ASSIGNED" && this.field_incident.assigned_date == "") {
                        this.field_incident.assigned_date = this.$moment(new Date()).format("YYYY-MM-DD")
                    }
                    //When changing status to assigned auto populate field with today's date only if previously not filled in
                    if (val == "CLOSED" && this.field_incident.closed_date == "") {
                        this.field_incident.closed_date = this.$moment(new Date()).format("YYYY-MM-DD")
                    }

                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
    };
</script>
